import { ErrorMessage, Field } from 'formik';
import { Col, Form, Row, Stack } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../../components/forms';
import Editor from '../../../../../../components/editor/Editor';
import { StepProps } from '../AddEditSession';

export const AdditionalInfoForm = ({ touched, errors, readOnly }: StepProps) => {
  return (
    <Row>
      <Col
        xs={12}
        lg={12}
      >
        <Stack gap={5}>
          <FormStepHeader
            title="Additional Information"
            showRequiredLegend={false}
          />
          <Form.Group controlId="admin_notes">
            <FormLabel>Admin Session Notes</FormLabel>
            <Field
              name="admin_notes"
              component={Editor}
              placeholder="Type here"
              className="form-control"
              disabled={readOnly}
            />
            <Form.Text>
              Admin notes are only visible to admin on the SFC Dashboard. These notes are not
              visible on the roster to the school or to SFC instructors.
            </Form.Text>
            <ErrorMessage
              name="admin_notes"
              component="span"
              className="text-danger fs-small"
            />
          </Form.Group>

          <Form.Group controlId="description">
            <FormLabel>Information for Browsing Parents</FormLabel>
            <Field
              name="description"
              component={Editor}
              placeholder="Type here"
              className="form-control"
              disabled={readOnly}
            />
            <Form.Text>
              These details are visible on the Front End for unregistered parents and should include
              important information needed before signing up.
            </Form.Text>
            <ErrorMessage
              name="description"
              component="span"
              className="text-danger fs-small"
            />
          </Form.Group>

          <Form.Group controlId="registered_information">
            <FormLabel>Information for Registered Parents</FormLabel>
            <Field
              name="registered_information"
              component={Editor}
              placeholder="Type here"
              className="form-control"
              disabled={readOnly}
            />
            <Form.Text>
              This text-box should include important information parents need to know after they
              have signed up. These details are displayed for each registered parent in their member
              account. In addition, these details automatically propogate onto the Welcome emails.
            </Form.Text>
            <ErrorMessage
              name="registered_information"
              component="span"
              className="text-danger fs-small"
            />
          </Form.Group>
        </Stack>
      </Col>
    </Row>
  );
};
